import { cdiService } from '../services'

export default (categoryBarGraphFilter) => {
  return new Promise((resolve, reject) => {
    cdiService.barGraph(categoryBarGraphFilter)
      .then(response => resolve(response))
      .catch(err => reject({ error: true }))
  })
}
